export class AnalyticUser {
  id;
  accountNonExpired;
  accountNonLocked;
  address1;
  address2;
  allowedVenueGroups;
  associateId;
  city;
  clientList;
  country;
  credentialsNonExpired;
  defaultClientId;
  defaultVenueGroup;
  emailAddress;
  employeeId;
  enabled;
  firstName;
  lastName;
  mobilePhone;
  password;
  primaryPhone;
  secondaryPhone;
  securityGroup;
  securityGroupId;
  state;
  username;
  zipcode;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/analytics-users/analytic-user.model.ts